import { Tolerance } from '@steelbuy/ts-shared';

export const shouldShowVat = (taxPercent?: number): boolean => (taxPercent ?? 0) > 0;

export const shouldShowTolerance = (tolerance?: Tolerance): boolean =>
    tolerance !== undefined && tolerance !== Tolerance.NA;
